import List from "components/list";
import { useParams } from "react-router-dom";
import { usePermissions } from "contexts/permission";
import { Button } from "ui/index";
import { Icon } from "components/index";
import { EDIT } from "icons/src";
import EmployeeInput from "components/employee/input";
import { useUpdateDepartment } from "@/modules/master-data/departments/crud/update/mutation";
import { eventBus } from "utils/eventBus";
import { UserFieldInput } from "permissions/components/user-field-input";
import { ROUTE } from "@/lib/utils";

export default function DepartmentCoordinatorList() {
  const { employeeId } = useParams();
  const permissions = usePermissions();
  const canEditCoordinator = permissions.hasFieldAccess(
    "departments",
    "update",
    "coordinators",
  );
  const userFilter = employeeId
    ? { coordinator: { _eq: employeeId } }
    : { coordinator: { user: { _eq: "$CURRENT_USER" } } };
  const fields = [
    "id",
    "name",
    "coordinators.id",
    "coordinators.coordinator.id",
    "coordinators.coordinator.first_name",
    "coordinators.coordinator.last_name",
    "coordinators.coordinator.avatar",
  ];

  const storageKey = employeeId
    ? `profile-dept-coordinator-${employeeId}`
    : "profile-dept-coordinator";

  const updateDeptMutation = useUpdateDepartment();

  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "coordinators",
      header: "Coordinators",
      hidden: !canEditCoordinator,
      href: false,
      cell: ({ row }) => {
        const dept = row.original;
        const currentCoordinators =
          dept.coordinators?.map((c) => c.coordinator).filter(Boolean) || [];
        return (
          <UserFieldInput
            targetItem={dept.id}
            field="coordinators"
            collection="departments"
            showWhenDisabled={false}
          >
            <EmployeeInput
              set="department_coordinating"
              value={currentCoordinators}
              multiselect={true}
              allowRemoval={true}
              footer={({ setOpen, selectedEmployees }) => (
                <Button
                  onClick={async () => {
                    await updateDeptMutation.mutateAsync({
                      departmentId: dept.id,
                      item: {
                        coordinators: selectedEmployees,
                      },
                    });
                    eventBus.emit("refresh:list", `departments${storageKey}`);
                    setOpen(false);
                  }}
                >
                  Assign
                </Button>
              )}
            >
              <Button variant="ghost">
                <Icon icon={EDIT} />
              </Button>
            </EmployeeInput>
          </UserFieldInput>
        );
      },
    },
  ];

  const filters = {
    coordinators: userFilter,
  };

  return (
    <List
      title="Departments"
      storageKey={storageKey}
      endPoint="departments"
      filters={filters}
      columns={columns.filter((col) => !col.hidden)}
      meta={{ fields }}
      sortBy="name"
      href={(item) => ROUTE.DEPARTMENT(item.id)}
    />
  );
}
